import { AcButton } from '../ui';
import type { ReportDailyPoint, ReportMetric } from './report-types';
/** Reuses the approved doctor-report/report.js spark geometry. KpiBand's bar
 * spark cannot represent two periods or null gaps; this is that report-specific
 * adapter, with the same AcButton drill and the existing DataTable for values. */
export default function ReportDailySeries({ selected, comparison, metric, label, onClick }: {
    selected: readonly ReportDailyPoint[];
    comparison: readonly ReportDailyPoint[] | null;
    metric: ReportMetric['key'];
    label: string;
    onClick: () => void;
}) {
    const values = (points: readonly ReportDailyPoint[]) => points.map(p => p.metrics.find(m => m.key === metric)?.value ?? null);
    const current = values(selected), previous = values(comparison ?? []);
    const finite = (v: number | null): v is number => v !== null && Number.isFinite(v);
    const max = Math.max(...current.filter(finite), ...previous.filter(finite), 1);
    const paths = (series: readonly (number | null)[]) => { let run: [
        number,
        number
    ][] = []; const result: [
        number,
        number
    ][][] = []; series.forEach((v, i) => { if (!finite(v)) {
        if (run.length)
            result.push(run);
        run = [];
    }
    else
        run.push([i * 160 / Math.max(series.length - 1, 1), 26 - v / max * 23]); }); if (run.length)
        result.push(run); return result; };
    const draw = (series: readonly (number | null)[], prior: boolean) => paths(series).map((points, i) => points.length === 1 ? <circle key={i} cx={points[0]![0]} cy={points[0]![1]} r="1.6" fill={prior ? 'white' : 'var(--ac-reference-color-17675f)'} stroke={prior ? 'var(--ac-reference-color-a8bcb0)' : 'var(--ac-reference-color-17675f)'}/> : <polyline key={i} points={points.map(p => p.join(',')).join(' ')} fill="none" stroke={prior ? 'var(--ac-reference-color-a8bcb0)' : 'var(--ac-reference-color-17675f)'} strokeDasharray={prior ? '3 3' : undefined} strokeWidth="1.6"/>);
    const available = [...current, ...previous].some(finite);
    return <AcButton variant="ghost" className="clinic-report__daily" disabled={!available} onClick={onClick} aria-label={`${label} daily series`} title={`Selected ${selected[0]?.date ?? 'Unavailable'} to ${selected[selected.length-1]?.date ?? 'Unavailable'}; comparison ${comparison?.[0]?.date ?? 'off'} to ${comparison?.[comparison.length-1]?.date ?? 'off'}. Solid selected, dashed comparison; missing days are gaps.`}>
 {available ? <svg viewBox="0 0 160 28" aria-hidden="true">{draw(previous, true)}{draw(current, false)}</svg> : <span>Daily series unavailable</span>}
 </AcButton>;
}
